import './App.css';
import {useEffect, useState} from 'react';
import HeaderBar from "./components/header-bar/header-bar";
import socketService from "./services/socket";
import RoomJoin from "./pages/room-join/room-join";
import SelectClass from "./pages/select-class/select-class";
import StartBattle from "./pages/start-battle/start-battle";
import SelectAtack from "./pages/select-atack/select-atack";
import SelectDefense from "./pages/select-defense/select-defense";
import FinishGame from "./pages/finish-game/finish-game";
import LifeBar from "./components/life-bar/life-bar";
import NotificationAlert from "./components/notificationAlert/notificationAlert";

function App() {
    const [showModal, setShowModal] = useState(false);
    const [firstTurn, setFirstTurn] = useState(true);
    const [showMessageAlert, setShowMessageAlert] = useState('');
    const [typeMessageAlert, setTypeMessageAlert] = useState('default');
    const [attackToDefense, setAttackToDefense] = useState(null);
    const [showAvatar, setShowAvatar] = useState(false);
    const [roomWant, setRoomWant] = useState(null);
    const [healthMe, setHealthMe] = useState(100);
    const [manaMe, setManaMe] = useState(100);
    const [roomJoined, setRoomJoined] = useState(null);
    const [stepPlayer, setStepPlayer] = useState('createRoom');
    const [detailClass, setDetailClass] = useState(null);
    const [statusEndGame, setStatusEndGame] = useState(null);

    useEffect(() => {
        socketService.connect('https://magicfight.dotamzi.com');

        socketService.on('roomCreated', (data) => {
            setRoomJoined(data);
        });

        socketService.on('waitOpponent', () => {
            setStepPlayer('waitOpponent');
        })

        socketService.on('error', (data) => {
           setShowMessageAlert(data);
           setTypeMessageAlert(`error`);
        });

        socketService.on('updateMana', (data) => {
           setShowMessageAlert(`- mana ${data.manaCoust}`);
           setTypeMessageAlert(`info`);
           setManaMe(data.manaRemaining);
        });

        socketService.on('changeRound', (data) => {
            console.log('changeRound', data);
           setShowMessageAlert(`+ mana ${data.manaAdd}`);
           setTypeMessageAlert(`info`);
        });

        socketService.on('roomJoined', (data) => {
            setRoomJoined(data);
            setShowModal(false);
        });

        socketService.on('updateHealth', (data) => {
            if (data.defenderId === socketService.getId()) {
                setHealthMe(data.defenderHealth);
            }
        });

        socketService.on('bothPlayersJoined', () => {
            setStepPlayer('selectClass');
        });

        socketService.on('startBattle', () => {
            setStepPlayer('startBattle');
        });

        socketService.on('yourTurn', () => {
            setFirstTurn(false);
            setStepPlayer('yourTurn');
        });

        socketService.on('defend', (defendData) => {
            setStepPlayer('defend');
            setAttackToDefense(defendData.attack);
        });

        socketService.on('gameOver', ({winnerId}) => {
            if (socketService.getId() === winnerId) {
                setStatusEndGame('win')
            } else {
                setStatusEndGame('lose');
            }
            setStepPlayer(null)
            setFirstTurn(true)
            setRoomWant(null)
            setRoomJoined(null)
            setDetailClass(null)
            setHealthMe(100);
            setShowAvatar(false);
        });

        return () => {
            socketService.disconnect();
        };
    }, []);

    return (
        <div className="App">
            <header className="App-header">
                <HeaderBar room={roomJoined} detailClass={detailClass} showAvatar={showAvatar}></HeaderBar>
            </header>
            <div className="body-data">
                <NotificationAlert style={{
                    position: 'absolute',
                    bottom: '0px',
                    right: '10px',
                }} text={showMessageAlert} type={typeMessageAlert} duration={2000} />

                {(stepPlayer === 'createRoom' || stepPlayer === 'stepConnection') &&
                        <RoomJoin setRoomWant={setRoomWant} roomWant={roomWant} setShowModal={setShowModal}
                                  showModal={showModal} stepPlayer={stepPlayer} setStepPlayer={setStepPlayer}/>
                }
                {(stepPlayer === 'selectClass' || stepPlayer === 'chosenCharacter') &&
                    <SelectClass roomSelected={roomJoined} detailClass={detailClass}
                                                              setDetailClass={setDetailClass}
                                                              stepPlayer={stepPlayer}
                                                              setStepPlayer={setStepPlayer}
                                                              setShowAvatar={setShowAvatar}/>
                }
                {(stepPlayer === 'startBattle' || stepPlayer === 'waitOpponent') && <StartBattle firstTurn={firstTurn}/>}
                {stepPlayer === 'yourTurn' && <SelectAtack classSelected={detailClass} roomCode={roomJoined} />}
                {stepPlayer === 'defend' && <SelectDefense classSelected={detailClass} roomCode={roomJoined}
                    enemyAttack={attackToDefense} />}
                {statusEndGame !== null && <FinishGame statusGame={statusEndGame}/>}

                <br/>
                {(stepPlayer !== 'createRoom' && stepPlayer !== 'selectClass' && stepPlayer !== 'stepConnection'
                    && stepPlayer !== 'chosenCharacter' && stepPlayer !== null)
                    && <LifeBar health={healthMe} mana={manaMe}/>}
            </div>
        </div>
    )
        ;
}

export default App;
